<template>
  <WModal v-model="modal" :title="$t('modal.logout.title')">
    <template #default>
      <NotificationBadge
        class="mx-0 badge-color-notification"
        color="blue-300"
        :text="$t('modal.logout.notification')"
      >
      </NotificationBadge>
      <p class="text-base text-blue-500 mb-3 mt-3">
        {{ $t('modal.logout.content') }}
      </p>
    </template>
    <template #footer>
      <WButton
        variant="primary"
        :pill="true"
        class="px-4"
        data-testid="forced-logout-modal-ok-button"
        @click="hide"
      >
        {{ $t('button.ok') }}
      </WButton>
    </template>
  </WModal>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'
import { WModal, WButton } from '@wiosna-dev/wiosna-ui'

import NotificationBadge from '@/components/widgets/NotificationBadge.vue'

const modal = ref(false)
const authStore = useAuthStore()
const { forcedToLogout } = storeToRefs(authStore)
const route = useRoute()

const hide = () => {
  modal.value = false
  authStore.forcedToLogout = false
}

watch(
  () => route.name,
  (routeName) => {
    if (routeName === 'Login' && forcedToLogout.value) {
      modal.value = true
    }
  }
)

onMounted(() => {
  if (forcedToLogout.value) {
    modal.value = true
  }
})
</script>
